import { render, staticRenderFns } from "./DataplexParameterComponent.vue?vue&type=template&id=5ac25e40&lang=pug"
import script from "./DataplexParameterComponent.vue?vue&type=script&lang=js"
export * from "./DataplexParameterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac25e40')) {
      api.createRecord('5ac25e40', component.options)
    } else {
      api.reload('5ac25e40', component.options)
    }
    module.hot.accept("./DataplexParameterComponent.vue?vue&type=template&id=5ac25e40&lang=pug", function () {
      api.rerender('5ac25e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/data_quality_dataplex/components/DataplexParameterComponent.vue"
export default component.exports